import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const SystemContext = createContext();

export const SystemProvider = ({ children }) => {
  const [activatedSystems, setActivatedSystems] = useState({});
  const [loadedSystems, setLoadedSystems] = useState({});
  const [showHistory, setShowHistory] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsedState] = useState(() => {
    return localStorage.getItem('isSidebarCollapsed') === 'true';
  });
  const [activeProfile, setActiveProfileState] = useState(() => {
    try {
      const saved = localStorage.getItem('holding_active_profile');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });

  const setIsSidebarCollapsed = useCallback((value) => {
    setIsSidebarCollapsedState(value);
    localStorage.setItem('isSidebarCollapsed', value.toString());
  }, []);

  const setActiveProfile = useCallback((profile) => {
    setActiveProfileState(profile);
    if (profile) {
      localStorage.setItem('holding_active_profile', JSON.stringify(profile));
    } else {
      localStorage.removeItem('holding_active_profile');
    }
  }, []);

  const setHistoryVisible = useCallback((visible) => {
    setShowHistory(visible);
  }, []);

  const activateSystem = useCallback((id, initialUrl, force = false) => {
    setActivatedSystems(prev => {
      const current = prev[id];
      if (current && current.initialUrl === initialUrl && !force) return prev; 
      return { 
        ...prev, 
        [id]: { 
          activated: true, 
          initialUrl, 
          timestamp: Date.now() 
        } 
      };
    });
  }, []);

  const resetSystem = useCallback((id) => {
    setActivatedSystems(prev => {
      const next = { ...prev };
      delete next[id];
      return next;
    });
    setLoadedSystems(prev => {
      const next = { ...prev };
      delete next[id];
      return next;
    });
  }, []);

  const setSystemLoaded = useCallback((id) => {
    setLoadedSystems(prev => ({ ...prev, [id]: true }));
  }, []);

  return (
    <SystemContext.Provider value={{ 
      activatedSystems, 
      loadedSystems, 
      showHistory,
      setHistoryVisible,
      isSidebarCollapsed,
      setIsSidebarCollapsed,
      activeProfile,
      setActiveProfile,
      activateSystem, 
      setSystemLoaded,
      resetSystem
    }}>
      {children}
    </SystemContext.Provider>
  );
};

export const useSystems = () => useContext(SystemContext);
